import { render, staticRenderFns } from "./Invoices.vue?vue&type=template&id=79dc5d1c"
import script from "./Invoices.vue?vue&type=script&lang=ts"
export * from "./Invoices.vue?vue&type=script&lang=ts"
import style0 from "./Invoices.vue?vue&type=style&index=0&id=79dc5d1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports